import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { useAuthContext } from "@/features/auth/auth-provider";
import { OAuthCallbackPage } from "@/features/auth/oauth-callback-page";
import { takePostLoginRedirect } from "@/lib/post-login-redirect";

export const Route = createFileRoute("/auth/callback")({
	component: OAuthCallbackRoute,
});

function OAuthCallbackRoute() {
	const navigate = useNavigate();
	const { refreshToken } = useAuthContext();

	const handleSuccess = useCallback(() => {
		void (async () => {
			try {
				await refreshToken();
				const next = takePostLoginRedirect();
				if (next) navigate({ href: next });
				else navigate({ to: "/dashboard" });
			} catch {
				navigate({ to: "/auth/login" });
			}
		})();
	}, [navigate, refreshToken]);

	const handleError = useCallback(() => {
		navigate({ to: "/auth/login" });
	}, [navigate]);

	return <OAuthCallbackPage onSuccess={handleSuccess} onError={handleError} />;
}
